export abstract class StorageAdapter {
  abstract set<Value>(key: string, value: Value): void;
  abstract get<Value>(key: string): Promise<Value>;
  abstract getBlocking<Value>(key: string): Value;
  abstract remove(key: string): void;
  abstract removeAll(): void;
}
